import Avatar from '@app/src/components/Ui/Avatar'
import { AssessmentOutlined, AutoAwesomeOutlined, DriveFileRenameOutlineOutlined } from '@mui/icons-material'
import React from 'react'

export enum TemplateTypeId {
  AiScreening = 'aiScreening',
  Questionnaire = 'questionnaire',
  Assessment = 'assessment',
}

export interface TemplateTypeConfig {
  id: TemplateTypeId
  icon: React.ReactElement
  bgColor: string
  titleId: string
  descriptionId: string
  sidetitleId?: string
  bulletPointIds?: string[]
  chipIds?: string[]
}

export const TEMPLATE_TYPES: Record<TemplateTypeId, Omit<TemplateTypeConfig, 'id'>> = {
  [TemplateTypeId.AiScreening]: {
    icon: <AutoAwesomeOutlined sx={{ color: 'communication.dark' }} />,
    bgColor: 'communication.main',
    titleId: 'questionnaireConfig.aiScreening.title',
    descriptionId: 'questionnaireConfig.aiScreening.description',
    bulletPointIds: [
      'questionnaireConfig.aiScreening.bullet1',
      'questionnaireConfig.aiScreening.bullet2',
      'questionnaireConfig.aiScreening.bullet3',
    ],
  },
  [TemplateTypeId.Questionnaire]: {
    icon: <DriveFileRenameOutlineOutlined sx={{ color: 'secondary.light' }} />,
    bgColor: 'visualization.11',
    titleId: 'questionnaireConfig.filters.questionnaires',
    descriptionId: 'questionnaireConfig.questionnaireDescription',
    bulletPointIds: [
      'questionnaireConfig.questionnaire.bullet1',
      'questionnaireConfig.questionnaire.bullet2',
      'questionnaireConfig.questionnaire.bullet3',
    ],
  },
  [TemplateTypeId.Assessment]: {
    icon: <AssessmentOutlined sx={{ color: 'secondary.light' }} />,
    bgColor: 'success.main',
    titleId: 'questionnaireConfig.filters.assessments',
    descriptionId: 'questionnaireConfig.assessmentsDescription',
    sidetitleId: 'questionnaireConfig.assessmentTitle',
    chipIds: [
      'questionnaireConfig.aiScreening.title',
      'questionnaireConfig.filters.questionnaires',
      'questionnaireConfig.both',
    ],
  },
}

export const getTemplateTypeConfig = (id: TemplateTypeId): TemplateTypeConfig => ({
  id,
  ...TEMPLATE_TYPES[id],
})

export const createTemplateTypeAvatar = (
  config: Pick<TemplateTypeConfig, 'icon' | 'bgColor'>,
  size: { width: number; height: number } = { width: 56, height: 56 },
) => (
  <Avatar variant="circular" sx={{ bgcolor: config.bgColor, ...size }}>
    {config.icon}
  </Avatar>
)
